import React, { useEffect, useState } from 'react';
import Cropper from 'react-easy-crop';

const ImageUploadCrop = ({ currentImage, defaultImage, width, height, onImageUpload }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [cropSize, setCropSize] = useState({ width: width, height: height });
    const [zoom, setZoom] = useState(1);
    const [croppedImage, setCroppedImage] = useState(null);

    const handleImageClick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = handleImageUpload;
        input.click();
    };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(URL.createObjectURL(file));
        }
    };

    const onCropComplete = (_, croppedAreaPixels) => {
        getCroppedImage(selectedImage, croppedAreaPixels, width, height, (base64Image) => {
            setCroppedImage(base64Image);
            onImageUpload(base64Image);
        });
    };

    useEffect(() => {
        if (defaultImage) {
            setSelectedImage(defaultImage);
        }
    }, []);

    return (
        <div>
            <div className='img-thumbnail d-inline-block float-start'>
                {currentImage ? (
                    <>
                        <img src={currentImage} className='img-fluid' alt='' width={width} height={height} />
                    </>
                ) :
                    !selectedImage ? (
                        <div
                            onClick={handleImageClick}
                            style={{ width, height, border: '2px dashed #ccc', cursor: 'pointer' }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                Click to upload image
                            </div>
                        </div>
                    ) : (

                        <div className='position-relative' style={{ width, height }}>
                            <Cropper
                                image={selectedImage}
                                crop={crop}
                                cropSize={cropSize}
                                zoom={zoom}
                                aspect={width / height}
                                restrictPosition={false}
                                showGrid={false}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>
                    )}
            </div>
        </div>
    );
};

const getCroppedImage = (imageSrc, croppedAreaPixels, width, height, callback) => {
    const image = new Image();
    image.src = imageSrc;

    image.onload = () => {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            croppedAreaPixels.x * scaleX,
            croppedAreaPixels.y * scaleY,
            croppedAreaPixels.width * scaleX,
            croppedAreaPixels.height * scaleY,
            0,
            0,
            width,
            height
        );

        canvas.toBlob(
            (blob) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    callback(reader.result);
                };
            },
            'image/png',
            1
        );
    };
};

export default ImageUploadCrop;
